import { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

import moment from "moment";

import { TaskDocument } from "../../task/task.model";
import { useComplaintTasks } from "../../workflow/follow-up/appointment/TaskProvider";
import { DetermineProposalTab } from "./DetermineProposalTab";

export const IntegratedDetermineProposalTab = () => {
    const history = useHistory();
    const goToTask = useCallback((task: TaskDocument) => {
        history.push(`/complaint/determine-proposal/${task.id}`);
    }, [history]);

    const now = moment().toISOString(true);

    const tasks = useComplaintTasks();

    const relevantTasks = useMemo(() => tasks.filter(task => task.complaint.status === "determining proposal"), [tasks]);
    const currentTasks = useMemo(() => relevantTasks.filter(task => task.performAfterDate <= now), [relevantTasks, now]);
    const futureTasks = useMemo(() => relevantTasks.filter(task => task.performAfterDate > now), [relevantTasks, now]);

    return (
        <DetermineProposalTab
            currentTasks={currentTasks}
            futureTasks={futureTasks}
            goToTask={goToTask}
        />
    );
};
